// CO1 — boss AoE telegraph readability. A pure helper mapping a telegraph's remaining time to its look:
// the danger disc fills in, a bright rim sharpens, and a "fuse" ring contracts toward the centre so the
// player reads the timing at a glance. Render-only — no sim/balance impact. Pure + headless-testable.

function clamp01(x: number): number {
  return x < 0 ? 0 : x > 1 ? 1 : x
}

export interface TelegraphLook {
  /** 0 at spawn → 1 at detonation. */
  progress: number
  /** filled danger-zone opacity (ramps up as it arms). */
  fillOpacity: number
  /** bright rim-ring opacity (sharp edge so the zone reads even on busy ground). */
  rimOpacity: number
  /** radius fraction of the contracting "fuse" ring (1 → 0 as it nears detonation). */
  fuseScale: number
}

export function telegraphLook(timer: number, maxTimer: number): TelegraphLook {
  const remaining = maxTimer > 0 ? clamp01(timer / maxTimer) : 0
  const progress = 1 - remaining
  return {
    progress,
    fillOpacity: 0.12 + 0.34 * progress,
    rimOpacity: 0.4 + 0.6 * progress,
    fuseScale: remaining,
  }
}
